import axios from "axios";

let urlAPI = "https://apiborgoolistico.amark.pro/";
let axiosInstance = axios.create({
  baseURL: urlAPI,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("token")}`,
  },
});

export { urlAPI, axiosInstance };
